function h(s, t, e) {
  s.insertBefore(t, e || null);
}
function d(s) {
  s.parentNode && s.parentNode.removeChild(s);
}
function u(s) {
  const t = {};
  for (const r in s)
    t[r] = [e(s[r])];
  function e(r) {
    return function() {
      return {
        c: function() {
        },
        // noop
        m: function(n, i) {
          h(n, r.cloneNode(!0), i);
        },
        d: function(n) {
          n && d(r);
        },
        l: function() {
        }
        // noop
      };
    };
  }
  return t;
}
function a(s) {
  let t = s.parentElement;
  for (; t; ) {
    if (t.tagName.indexOf("-") !== -1)
      return t;
    t = t.parentElement;
  }
  return null;
}
function c(s) {
  let t = document.createDocumentFragment();
  for (; s.firstChild; )
    t.appendChild(s.firstChild);
  return t;
}
const l = /* @__PURE__ */ new Map(), f = new MutationObserver((s) => {
  s.forEach((t) => {
    const e = t.target, r = t.attributeName, o = e.getAttribute(r);
    e.forwardAttributeToProp(r, o);
  });
});
function g(s) {
  let t = document.querySelectorAll("[data-svelte-retag-render]");
  if (t.length !== 0)
    for (let e of t)
      e.isConnected && e.parentElement.closest('[data-svelte-retag-render="light"]') === null && (e.removeAttribute("data-svelte-retag-render"), e._renderSvelteComponent());
}
function m(s) {
  window.customElements.get("svelte-retag") || (window.customElements.define("svelte-retag", class extends HTMLElement {
    // noop
  }), window.customElements.define("svelte-retag-default", class extends HTMLElement {
    // noop
  })), window.customElements.define(s.tagname, class extends HTMLElement {
    constructor() {
      if (super(), this._debug("constructor()"), this.attributesObserved = !1, s.shadow && (this.attachShadow({ mode: "open" }), this._root = document.createElement("svelte-retag"), this.shadowRoot.appendChild(this._root), s.href)) {
        let t = document.createElement("link");
        t.setAttribute("href", s.href), t.setAttribute("rel", "stylesheet"), this.shadowRoot.appendChild(t);
      }
    }
    /**
     * Attributes we're watching for changes after render (doesn't affect attributes already present prior to render).
     *
     * NOTE: This only applies if opts.attributes is an array. If opts.attributes is true, then all attributes are
     * watched using the mutation observer instead.
     *
     * @returns string[]
     */
    static get observedAttributes() {
      return Array.isArray(s.attributes) ? s.attributes : [];
    }
    /**
     * Attached to DOM.
     */
    connectedCallback() {
      this._debug("connectedCallback()"), this.slotEls = {};
      const t = document.readyState === "loading";
      if (!s.shadow)
        if (this.hasAttribute("data-svelte-retag-hydratable"))
          if (t) {
            this._onSlotsReady(() => {
              this._initLightRoot(), this._hydrateLightSlots(), this._queueForRender();
            });
            return;
          } else
            this._initLightRoot(), this._hydrateLightSlots();
        else
          this._initLightRoot();
      s.shadow ? this._observeSlots(!0) : t && (this._observeSlots(!0), this._onSlotsReady(() => {
        this._observeSlots(!1);
      })), this._queueForRender(), s.hydratable && this.setAttribute("data-svelte-retag-hydratable", "");
    }
    /**
     * Removed from DOM (could be called inside another custom element that starts rendering after this one). In that
     * situation, the connectedCallback() will be executed again (most likely with constructor() as well, unfortunately).
     */
    disconnectedCallback() {
      if (this._debug("disconnectedCallback()"), this.removeAttribute("data-svelte-retag-render"), this.removeAttribute("data-svelte-retag-hydratable"), this._observeSlots(!1), this.componentInstance)
        try {
          this.componentInstance.$destroy(), delete this.componentInstance;
        } catch (t) {
          console.error(`Error destroying Svelte component in '${this.tagName}'s disconnectedCallback(): ${t}`);
        }
      s.shadow || (this._restoreLightSlots(), this.removeChild(this._root));
    }
    /**
     * Callback/hook for observedAttributes.
     *
     * @param {string} name
     * @param {string} oldValue
     * @param {string} newValue
     */
    attributeChangedCallback(t, e, r) {
      this._debug("attributes changed", { name: t, oldValue: e, newValue: r }), this.forwardAttributeToProp(t, r);
    }
    /**
     * Forward modifications to element attributes to the corresponding Svelte prop (if applicable).
     *
     * @param {string} name
     * @param {string} value
     */
    forwardAttributeToProp(t, e) {
      if (this._debug("forwardAttributeToProp", { name: t, value: e }), this.componentInstance) {
        let r = this._translateAttribute(t);
        this.componentInstance.$set({ [r]: e });
      }
    }
    /**
     * Setup a wrapper in the light DOM which can keep the rendered Svelte component separate from the default Slot
     * content, which is potentially being actively appended (at least while the browser parses during loading).
     */
    _initLightRoot() {
      let t = this.querySelector("svelte-retag");
      t !== null && t.parentElement === this ? (this._debug("_initLightRoot(): Restore from existing light DOM root"), this._root = t) : (this._root = document.createElement("svelte-retag"), this.prepend(this._root));
    }
    /**
     * Queues the provided callback to execute when we think all slots are fully loaded and available to fetch and
     * manipulate.
     *
     * @param {callback} callback
     */
    _onSlotsReady(t) {
      document.addEventListener("readystatechange", () => {
        document.readyState === "interactive" && t();
      });
    }
    /**
     * Converts the provided lowercase attribute name to the correct case-sensitive component prop name, if possible.
     *
     * @param {string} attributeName
     * @returns {string}
     */
    _translateAttribute(t) {
      return t = t.toLowerCase(), this.propMap && this.propMap.has(t) ? this.propMap.get(t) : (this._debug(`_translateAttribute(): ${t} not found`), t);
    }
    /**
     * To support context, this traverses the DOM to find potential parent elements (also managed by svelte-retag) which
     * may contain context necessary to render this component.
     *
     * See context functions at: https://svelte.dev/docs/svelte#setcontext
     *
     * @returns {Map|null}
     */
    _getAncestorContext() {
      var e, r;
      let t = this;
      for (; t.parentNode; ) {
        t = t.parentNode;
        let o = (r = (e = t == null ? void 0 : t.componentInstance) == null ? void 0 : e.$$) == null ? void 0 : r.context;
        if (o instanceof Map)
          return o;
      }
      return null;
    }
    /**
     * Queue this element for render in the next animation frame. This offers the opportunity to render known available
     * elements all at once and, ideally, from the top down (to preserve context).
     */
    _queueForRender() {
      if (!this.isConnected) {
        this._debug("queueForRender(): skipped, already disconnected");
        return;
      }
      if (this.parentElement.closest('[data-svelte-retag-render="light"]') !== null) {
        this._debug("queueForRender(): skipped, light DOM parent is queued for render");
        return;
      }
      this.setAttribute("data-svelte-retag-render", s.shadow ? "shadow" : "light"), requestAnimationFrame(g);
    }
    /**
     * Renders (or rerenders) the Svelte component into this custom element based on the latest properties and slots
     * (with slots initialized elsewhere).
     *
     * IMPORTANT:
     *
     * Despite the intuitive name, this method is private since its functionality requires a deeper understanding
     * of how it depends on current internal state and how it alters internal state. Be sure to study how it's called
     * before calling it yourself externally. ("Yarrr! Here be dragons! 🔥🐉")
     *
     * That said... this is currently the workflow:
     *
     * 1. Wait for connection to DOM
     * 2. Ensure slots are properly prepared (e.g. in case of hydration) or observed (in case actively parsing DOM, e.g.
     *    IIFE/UMD or shadow DOM) in case there are any changes *after* this render
     * 3. _queueForRender(): Kick off to requestAnimationFrame() to queue render of the component (instead of rendering
     *    immediately) to ensure that all currently connected and available components are taken into account (this is
     *    necessary for properly supporting context to prevent from initializing components out of order).
     * 4. renderElements(): Renders through the DOM tree in document order and from the top down (parent to child),
     *    reaching this element instantiating this component, ensuring context is preserved.
     *
     */
    _renderSvelteComponent() {
      this._debug("renderSvelteComponent()"), s.shadow ? this.slotEls = this._getShadowSlots() : this.slotEls = this._getLightSlots(), this._root.innerHTML = "";
      const t = this._getAncestorContext() || /* @__PURE__ */ new Map();
      let e = {
        $$scope: {},
        // Convert our list of slots into Svelte-specific slot objects
        $$slots: u(this.slotEls)
        // All other *initial* props are pulled dynamically from element attributes (see proxy below)...
      };
      if (!l.has(this.tagName))
        this.propMap = /* @__PURE__ */ new Map(), l.set(this.tagName, this.propMap), e = new Proxy(e, {
          get: (r, o) => {
            let n = o.toString();
            o.indexOf("$$") === -1 && this.propMap.set(n.toLowerCase(), n);
            let i = this.attributes.getNamedItem(n);
            return i !== null ? r[n] = i.value : r[o];
          }
        });
      else {
        this.propMap = l.get(this.tagName);
        for (let r of [...this.attributes])
          r.name.indexOf("data-svelte-retag") === -1 && (e[this._translateAttribute(r.name)] = r.value);
      }
      this.componentInstance = new s.component({ target: this._root, props: e, context: t }), s.attributes === !0 && !this.attributesObserved && (this.attributesObserved = !0, this.propMap.size > 0 ? f.observe(this, {
        attributes: !0,
        // implicit, but... 🤷‍♂️
        attributeFilter: [...this.propMap.keys()]
      }) : this._debug("renderSvelteComponent(): skipped attribute observer, no props")), this._debug("renderSvelteComponent(): completed");
    }
    /**
     * Fetches slots from pre-rendered Svelte component HTML using special markers (either data attributes or custom
     * wrappers). Note that this will only work during initialization and only if the Svelte retag instance is
     * hydratable.
     */
    _hydrateLightSlots() {
      let t = this._root.querySelectorAll("[data-svelte-retag-slot]");
      for (let r of t) {
        if (a(r) !== this._root)
          continue;
        let n = r.getAttribute("slot");
        this.slotEls[n] = r;
      }
      let e = this.querySelector("svelte-retag-default");
      return e !== null && (this.slotEls.default = e), this._restoreLightSlots(), !0;
    }
    /**
     * Indicates if the provided <slot> element instance belongs to this custom element or not.
     *
     * @param {Element} slot
     * @returns {boolean}
     */
    _isOwnSlot(t) {
      let e = a(t);
      return e === null ? !1 : e === this;
    }
    /**
     * Returns a map of slot names and the corresponding HTMLElement (named slots) or DocumentFragment (default slots).
     *
     * IMPORTANT: Since this custom element is the "root", these slots must be removed (which is done in THIS method).
     *
     * TODO: Problematic name. We are "getting" but we're also mangling/mutating state (which *is* necessary). "Get" may be confusing here; is there a better name?
     *
     * @returns {SlotList}
     */
    _getLightSlots() {
      this._debug("_getLightSlots()");
      let t = {};
      const e = this.querySelectorAll("[slot]");
      for (let i of e)
        this._isOwnSlot(i) && (t[i.slot] = i, s.hydratable && i.setAttribute("data-svelte-retag-slot", ""), this.removeChild(i));
      let r = document.createDocumentFragment();
      s.hydratable && (r = document.createElement("svelte-retag-default"));
      let o = [...this.childNodes], n = "";
      for (let i of o) {
        if (i instanceof HTMLElement && i.tagName === "SVELTE-RETAG") {
          this._debug("_getLightSlots(): skipping <svelte-retag> container");
          continue;
        }
        i instanceof Text ? n += i.textContent : i.outerHTML && (n += i.outerHTML), r.appendChild(i);
      }
      return n.trim() !== "" && (t.default ? console.error(`svelteRetag: '${this.tagName}': Found elements without slot attribute when using slot="default"`) : t.default = r), t;
    }
    /**
     * Go through originally removed slots and restore back to the custom element.
     */
    _restoreLightSlots() {
      this._debug("_restoreLightSlots:", this.slotEls);
      for (let t in this.slotEls) {
        let e = this.slotEls[t];
        e.tagName === "SVELTE-RETAG-DEFAULT" ? this.prepend(c(e)) : (this.prepend(e), e instanceof HTMLElement && e.hasAttribute("data-svelte-retag-slot") && e.removeAttribute("data-svelte-retag-slot"));
      }
      this.slotEls = {};
    }
    /**
     * Fetches and returns references to the existing shadow DOM slots. Left unmodified.
     *
     * @returns {SlotList}
     */
    _getShadowSlots() {
      this._debug("_getShadowSlots()");
      const t = this.querySelectorAll("[slot]");
      let e = {}, r = this.innerHTML.length;
      return t.forEach((o) => {
        e[o.slot] = document.createElement("slot"), e[o.slot].setAttribute("name", o.slot), r -= o.outerHTML.length;
      }), r > 0 && (e.default = document.createElement("slot")), e;
    }
    /**
     * Toggle on/off the MutationObserver used to watch for changes in child slots.
     */
    _observeSlots(t) {
      t !== this.slotObserverActive && (this.slotObserver || (this.slotObserver = new MutationObserver((e) => {
        this._processSlotMutations(e);
      })), t ? (this.slotObserver.observe(this, { childList: !0, subtree: !1, attributes: !1 }), this._debug("_observeSlots: OBSERVE")) : (this.slotObserver.disconnect(), this._debug("_observeSlots: DISCONNECT")), this.slotObserverActive = t);
    }
    /**
     * Watches for slot changes, specifically:
     *
     * 1. Shadow DOM: All slot changes will queue a rerender of the Svelte component
     *
     * 2. Light DOM: Only additions will be accounted for. This is particularly because currently we only support
     *    watching for changes during document parsing (i.e. document.readyState === 'loading', prior to the
     *    'DOMContentLoaded' event.
     *
     * @param {MutationRecord[]} mutations
     */
    _processSlotMutations(t) {
      this._debug("_processSlotMutations()", t);
      let e = !1;
      for (let r of t)
        if (r.type === "childList") {
          if (s.shadow) {
            e = !0;
            break;
          } else if (r.addedNodes.length > 0) {
            e = !0;
            break;
          }
        }
      e && (s.shadow || (this._observeSlots(!1), this._restoreLightSlots(), this._observeSlots(!0)), this._debug("_processMutations(): Queue rerender"), this._queueForRender());
    }
    /**
     * Pass through to console.log() but includes a reference to the custom element in the log for easier targeting for
     * debugging purposes.
     *
     * @param {...*}
     */
    _debug() {
      s.debugMode && (s.debugMode === "cli" ? console.log.apply(null, [performance.now(), this.tagName, ...arguments]) : console.log.apply(null, [performance.now(), this, ...arguments]));
    }
  });
}
function b() {
  document.querySelector("bluc-map") != null && import("./bluc-map-V5jWel-1.js").then((s) => {
    m({
      component: s.default,
      tagname: "bluc-map"
    });
  });
}
export {
  b as initializeMaps
};
//# sourceMappingURL=bluc-map.js.map
